import { useCallback, useEffect, useState } from "react";
import is from "@sindresorhus/is";

// import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { useTheme } from "@mui/material/styles";
// import useMediaQuery from "@mui/material/useMediaQuery";

import Heading from "../Heading/Heading";
import PostPreview from "../PostPreview/PostPreview";
import Popup from "../Popup/Popup";

import actions from "../../../data/actions";

const BAR_COLORS = ["#f9ca24", "#55efc4", "#e17055", "#74b9ff"];

const Services = props => {
  const theme = useTheme();

  const [popupContent, setPopupContent] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);
  const [posts, setPosts] = useState();
  const [title, setTitle] = useState();

  const bgcolor = theme.palette.background.paper;
  const color = theme.palette.getContrastText(bgcolor);

  const popupOnClose = useCallback(() => setPopupOpen(false), []);

  const postOnClick = useCallback(post => {
    setTitle(post.title);
    setPopupContent(post.content.html);
    setPopupOpen(true);
  }, []);

  // (init) -> posts
  useEffect(() => {
    Promise.resolve()
      .then(() => actions.getServicePosts())
      .then(posts => setPosts(posts))
      .catch(error => console.log(error));
  }, []);

  return (
    <>
      {is.array(posts) && (
        <>
          <Paper elevation={0} square sx={{ bgcolor, color }}>
            <Container disableGutters maxWidth="lg" sx={{ pt: 4, pb: 8, px: 2 }}>
              <Heading label={"Szolgáltatások"} sx={{ pb: 4 }} />
              <Grid container spacing={8}>
                {posts.map((post, index) => (
                  <Grid item key={post.id} xs={12} sm={6}>
                    <PostPreview barColor={BAR_COLORS[index % 4]} onClick={() => postOnClick(post)} text={post.excerpt.plain} title={post.title} />
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Paper>
          <Popup open={popupOpen} onClose={popupOnClose}>
            <Typography variant="h6" sx={{ color: theme.palette.primary.main }}>
              {title}
            </Typography>
            {popupContent}
          </Popup>
        </>
      )}
    </>
  );
};

export default Services;
